import * as React from 'react';
import Login from './UI/Login';

export default function App() {
  return (
    <Login />
  );
}
